module.exports = __webpack_public_path__ + "img/freebsd.14eb425a.svg";